module.exports = __webpack_public_path__ + "static/enza-web-c67fc7224ad60ed8f980140b26e94ccf.jpg";